import React, { FC } from 'react';
import { TableRow } from '@material-ui/core';
import { TableCellEnd, TableCellStart, TableCellMiddle } from 'components/Table';
import Skeleton from '@material-ui/lab/Skeleton';

interface Props {
  purchaseOrderItem: PurchaseOrderItemModel;
  isLoading: boolean;
  index: number;
}

const BodyRow: FC<Props> = props => {
  const { purchaseOrderItem, isLoading, index } = props;

  return (
    <TableRow>
      <TableCellStart>
        {isLoading ? <Skeleton variant='text' width={100} height={25} /> : `${index + 1}. ${purchaseOrderItem.productName || ''}`}
      </TableCellStart>
      <TableCellEnd>
        {isLoading ? <Skeleton variant='text' width={100} height={25} /> : purchaseOrderItem.totalItem + ' ' + purchaseOrderItem.typeUnit}
      </TableCellEnd>
    </TableRow>
  );
};

export default BodyRow;
